
import { ArrowDown } from 'lucide-react';

interface ScrollToBottomButtonProps {
  onClick: () => void;
  isVisible: boolean;
}

export const ScrollToBottomButton = ({ onClick, isVisible }: ScrollToBottomButtonProps) => {
  if (!isVisible) return null;
  
  return (
    <button
      onClick={onClick}
      className="fixed bottom-24 right-8 p-2 bg-primary text-white rounded-full shadow-lg hover:bg-primary/90 transition-all duration-200 animate-fade-in"
      aria-label="Scroll to bottom"
    >
      <ArrowDown className="h-5 w-5" />
    </button>
  );
};
